/* GCS Warenkorb – Relaunch David (Baustein 5)
   Öffentliche API (Bauvertrag Abschnitt 6, Signaturen bleiben):
     GCS.cart.add(items, { source, open = true })  → Promise<cart>   items: [{ id, quantity, properties?, selling_plan? }]
     GCS.cart.change(key, quantity, { source })    → Promise<cart>   key = Positions-Key (oder Variante; Zahl < 1000 = Zeile)
     GCS.cart.get()                                 → Promise<cart>
     GCS.cart.open() / GCS.cart.close()
   Erweiterungen: GCS.cart.refresh(), GCS.cart.isOpen(), GCS.cart.state (letzter /cart.js-Stand), GCS.cart.sources.
   Ablauf jeder Aktion: window.fetch zur Laufzeit (Tracking-Interceptors sehen den Call) → /cart.js lesen →
   publish(PUB_SUB_EVENTS.cartUpdate, { source, cartData, productVariantId }) → CustomEvent gcs:cart:updated → Zähler.
   Fehler: CustomEvent gcs:cart:error { message, source } + Reject. Parallele Aufrufe laufen nacheinander (Queue).
   Beträge kommen immer aus /cart.js; selbst gerechnet wird nur die Anzeige (Formatierung, Reward-Fortschritt).
   EGO/Opus Cart Upsell bleibt aktiv, seine Oberfläche ist aus (Flags unten, CSS in gcs-cart.css).
   Doku: docs/architecture/cart.md */
(() => {
  'use strict';

  const GCS = (window.GCS = window.GCS || {});
  if (GCS.cart && GCS.cart.__gcsCart) return;

  /* 1 EGO/Opus Cart Upsell: Oberfläche aus, Logik (Gratisartikel, Rabatt-Properties) an ---------------- */
  // Opus liest beide Flags erst im Moment des Klicks bzw. des Öffnens.
  window.opusBlockInstantAddToCart = true; // Opus-Drawer öffnet sich nie (Add-to-Cart, fetch-Listener, opusOpen)
  window.OpusNoATC = true; // Opus fängt Add-to-Cart-Buttons (form button[name="add"]) nicht ab

  const SOURCES = ['pdp', 'pack-selector', 'sticky', 'card', 'quick-add', 'drawer', 'cart-page', 'landingpage'];
  const META_SECTION = 'gcs-cart-meta';
  const DEFAULT_ERROR = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';

  /* 2 Hilfen -------------------------------------------------------------------------------------- */
  const settings = () => GCS.settings || {};
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const routes = () => {
    const r = settings().routes || {};
    return {
      cart: r.cart || root() + 'cart',
      cartChange: r.cartChange || root() + 'cart/change',
    };
  };
  const pubEvents = () => {
    // PUB_SUB_EVENTS ist in Dawns constants.js eine globale const (nicht window.PUB_SUB_EVENTS).
    try {
      // eslint-disable-next-line no-undef
      if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS) return PUB_SUB_EVENTS;
    } catch (e) {
      /* ignore */
    }
    return window.PUB_SUB_EVENTS || { cartUpdate: 'cart-update', cartError: 'cart-error' };
  };

  const esc = (value) =>
    String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const money = (cents) => {
    const out = typeof GCS.formatMoney === 'function' ? GCS.formatMoney(cents) : ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    return String(out).replace(/ €$/, ' €');
  };

  let EMOJI;
  try {
    EMOJI = new RegExp('[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{FE0E}\\u{FE0F}\\u{200D}\\u{20E3}]', 'gu');
  } catch (e) {
    EMOJI = /[☀-➿︎️‍⃣]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF]/g;
  }
  const cleanTitle = (title) => {
    let t = String(title || '').replace(EMOJI, '');
    if (t.toUpperCase().indexOf('(VORBESTELLUNG') > -1) t = t.split('(')[0];
    return t.replace(/\s+/g, ' ').trim();
  };

  const imgUrl = (src, width) => {
    if (!src) return '';
    const s = String(src).indexOf('//') === 0 ? 'https:' + src : String(src);
    try {
      const u = new URL(s, window.location.href);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return s;
    }
  };

  const OPTION_LABELS = { size: 'Größe', 'größe': 'Größe', groesse: 'Größe', 'grösse': 'Größe', color: 'Farbe', colour: 'Farbe', farbe: 'Farbe', fit: 'Passform', passform: 'Passform', title: '' };
  const optionValue = (value) => {
    const v = String(value || '');
    if (/^\d/.test(v)) return v.replace(/-/g, '–');
    if (v === v.toUpperCase() && /[A-ZÄÖÜ]/.test(v)) return v.charAt(0) + v.slice(1).toLowerCase();
    return v;
  };
  const variantText = (options) =>
    (options || [])
      .map((o) => {
        const name = String(o.name || '');
        const key = name.toLowerCase();
        const label = Object.prototype.hasOwnProperty.call(OPTION_LABELS, key) ? OPTION_LABELS[key] : name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
        return (label ? label + ' ' : '') + esc(optionValue(o.value));
      })
      .join(' · ');

  const packsLabel = (count) => (count > 0 ? `${count} ${count === 1 ? 'Pack' : 'Packs'}` : '');
  const isGift = (item) => !!(item && item.properties && item.properties.__cd_opus_free_gift);
  const signature = (cart) =>
    (cart && Array.isArray(cart.items) ? cart.items : []).map((i) => `${i.key}:${i.quantity}:${i.final_line_price}|`).join('') +
    '#' +
    (cart ? cart.total_price : 0);

  /* Paare pro Pack für Empfehlungen und Mini-Karten (gleiche Reihenfolge wie snippets/gcs-price.liquid;
     Bundle-Collections kennt das Produkt-JSON nicht) */
  const pairsForProduct = (product) => {
    const type = String((product && product.type) || '').toLowerCase();
    if (type === 'bundle' || type === 'underwear' || type === 'worldchanger') return 0;
    const desc = String((product && product.description) || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (desc.indexOf('1 paar') === 0) return 1;
    const tags = (product && product.tags) || [];
    if (tags.indexOf('3er-pack') > -1) return 3;
    return 2;
  };

  /* Icons aus <template data-gcs-cart-icons> (gerendert über snippets/gcs-icon.liquid) */
  const iconCache = {};
  const FALLBACK_ICONS = {
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    trash: '<path d="M4 7h16M9.5 7V4.5h5V7M6 7l1 13h10l1-13"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    close: '<path d="m6 6 12 12M18 6 6 18"/>',
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    truck: '<path d="M2.5 6.5h11v10h-11z"/><path d="M13.5 9.5h4l3.5 3.5v3.5h-7.5"/><circle cx="6.5" cy="17.5" r="1.75"/><circle cx="17" cy="17.5" r="1.75"/>',
  };
  const icon = (name, size = 16) => {
    if (!(name in iconCache)) {
      const tpl = document.querySelector('template[data-gcs-cart-icons]');
      const el = tpl && tpl.content.querySelector(`[data-icon="${name}"] svg`);
      iconCache[name] = el
        ? el.outerHTML
        : `<svg class="gcs-icon gcs-icon--${name}" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${FALLBACK_ICONS[name] || ''}</svg>`;
    }
    return iconCache[name].replace(/width="\d+"/, `width="${size}"`).replace(/height="\d+"/, `height="${size}"`);
  };

  /* 3 Zustand ------------------------------------------------------------------------------------- */
  const state = {
    cart: null,
    sig: null,
    busy: 0,
    lastAdded: null,
  };
  try {
    state.lastAdded = JSON.parse(window.sessionStorage.getItem('gcs:cart:lastAdded') || 'null');
  } catch (e) {
    state.lastAdded = null;
  }
  const rememberAdded = (item) => {
    if (!item) return;
    state.lastAdded = { productId: item.product_id, variantId: item.variant_id };
    try {
      window.sessionStorage.setItem('gcs:cart:lastAdded', JSON.stringify(state.lastAdded));
    } catch (e) {
      /* privater Modus */
    }
  };

  /* Zusatzdaten pro Variante (Paare, Vorbestellung): aus Liquid, weil /cart.js keine Tags/Bestände liefert */
  const meta = new Map();
  const readMeta = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('script[data-gcs-cart-meta]').forEach((node) => {
      try {
        const data = JSON.parse(node.textContent || '{}');
        Object.keys(data).forEach((key) => meta.set(String(key), data[key]));
      } catch (e) {
        /* ungültiges JSON ignorieren */
      }
    });
  };
  const readMetaHTML = (html) => {
    if (!html) return;
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    readMeta(tpl.content);
  };
  let metaRequest = null;
  const fetchMeta = () => {
    if (metaRequest) return metaRequest;
    metaRequest = window
      .fetch(`${routes().cart}?sections=${META_SECTION}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : {}))
      .then((data) => readMetaHTML(data && data[META_SECTION]))
      .catch(() => {})
      .finally(() => {
        metaRequest = null;
      });
    return metaRequest;
  };
  const metaMissing = (cart) => (cart && cart.items ? cart.items.some((i) => !meta.has(String(i.variant_id))) : false);

  /* 4 Requests ------------------------------------------------------------------------------------ */
  const ENGLISH = /\b(the|you|your|only|cannot|can't|is|are|not|sold|out|add|cart|item|quantity|please|try|again|minutes|error)\b/i;
  const RATE_LIMIT = 'Gerade kommen zu viele Anfragen an. Bitte versuch es in ein paar Minuten noch einmal.';
  const germanError = (message, status) => {
    const m = String(message || '').trim();
    if (status === 429 || status === 'too_many_requests' || /too many|try again in a few/i.test(m)) return RATE_LIMIT;
    if (!m) return DEFAULT_ERROR;
    if (!ENGLISH.test(m) || /[äöüß]/i.test(m)) return m;
    if (/sold out/i.test(m)) return 'Diese Größe ist gerade ausverkauft.';
    if (/only|maximum|all \d+|not enough|more than/i.test(m)) return 'Mehr ist von diesem Artikel gerade nicht verfügbar.';
    if (/not (be )?found|doesn't exist|does not exist|no longer/i.test(m)) return 'Dieser Artikel ist nicht mehr verfügbar.';
    return DEFAULT_ERROR;
  };

  const parse = async (response) => {
    let data = {};
    try {
      data = await response.json();
    } catch (e) {
      data = {};
    }
    if (!response.ok || (data && data.status && !Array.isArray(data.items))) {
      const description = (data && (data.description || data.message)) || '';
      const error = new Error(germanError(description, response.status === 429 ? 429 : data && data.status));
      error.description = description;
      error.status = (data && data.status) || response.status;
      error.data = data;
      throw error;
    }
    return data;
  };

  const post = (path, body) =>
    window
      .fetch(root() + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
      .then(parse);

  const fetchCart = () =>
    window
      .fetch(root() + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
      .then(parse);

  /* Queue: Aktionen laufen nacheinander. Zeitfenster eigener Calls, damit fremde Änderungen erkennbar sind. */
  let chain = Promise.resolve();
  const ownWindows = [];
  const enqueue = (task) => {
    const run = chain.then(async () => {
      const win = { start: performance.now(), end: Infinity };
      ownWindows.push(win);
      if (ownWindows.length > 40) ownWindows.shift();
      state.busy += 1;
      views.forEach((v) => v.syncBusy());
      try {
        return await task();
      } finally {
        win.end = performance.now() + 60;
        state.busy -= 1;
        views.forEach((v) => v.syncBusy());
      }
    });
    chain = run.catch(() => {});
    return run;
  };

  /* 5 Anzeige-Updates ----------------------------------------------------------------------------- */
  const views = new Set();

  /* Zähler springt, wenn Packs dazukommen (Impeccable G7). Liegt der Drawer offen über dem Header, springt er beim
     Schließen, damit die Bestätigung sichtbar ist. Bei „Bewegung reduzieren“ nur der neue Wert. */
  let lastCount = null;
  let bumpPending = false;
  const bumpCount = () => {
    bumpPending = false;
    document.querySelectorAll('[data-gcs-cart-count]').forEach((el) => {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  };
  document.addEventListener('gcs:drawer:close', (event) => {
    if (bumpPending && event.target && event.target.id === 'GcsCartDrawer') setTimeout(bumpCount, 180);
  });
  const updateCount = (cart) => {
    if (!cart || typeof cart.item_count !== 'number') return;
    if (lastCount === null) {
      const first = document.querySelector('[data-gcs-cart-count]');
      lastCount = first ? Number(first.dataset.count) || 0 : cart.item_count;
    }
    const grew = cart.item_count > lastCount;
    lastCount = cart.item_count;
    document.querySelectorAll('[data-gcs-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.dataset.count = String(cart.item_count);
    });
    if (grew) {
      const drawer = document.getElementById('GcsCartDrawer');
      if (drawer && drawer.isOpen) bumpPending = true;
      else requestAnimationFrame(bumpCount);
    }
    document.querySelectorAll('[data-gcs-cart-toggle]').forEach((el) => {
      el.setAttribute('aria-label', `Warenkorb, ${cart.item_count} Artikel`);
    });
  };

  const setCart = (cart, options = {}) => {
    if (!cart || !Array.isArray(cart.items)) return;
    state.cart = cart;
    state.sig = signature(cart);
    updateCount(cart);
    views.forEach((v) => v.render(cart, options));
    if (metaMissing(cart)) {
      fetchMeta().then(() => {
        if (state.cart === cart) views.forEach((v) => v.render(cart, { force: true }));
      });
    }
  };

  const emit = (cart, source, productVariantId, options = {}) => {
    setCart(cart, options);
    const events = pubEvents();
    if (typeof window.publish === 'function' && events.cartUpdate) {
      try {
        window.publish(events.cartUpdate, { source, cartData: cart, productVariantId, gcs: true });
      } catch (e) {
        /* Fehler in fremden Subscribern nicht durchreichen */
      }
    }
    document.dispatchEvent(new CustomEvent('gcs:cart:updated', { detail: { cart, source } }));
  };

  const fail = (error, source) => {
    const err = error instanceof Error ? error : new Error(DEFAULT_ERROR);
    if (!err.description && err.name === 'TypeError') err.message = 'Keine Verbindung. Bitte versuch es noch einmal.';
    document.dispatchEvent(new CustomEvent('gcs:cart:error', { detail: { message: err.message, source } }));
    const events = pubEvents();
    if (typeof window.publish === 'function' && events.cartError) {
      try {
        window.publish(events.cartError, { source, errors: err.message, message: err.message, gcs: true });
      } catch (e) {
        /* ignore */
      }
    }
    throw err;
  };

  /* EGO/Opus nach eigenen Änderungen synchronisieren (prüft Gratisartikel), ohne dass sein Drawer aufgeht */
  let opusTimer;
  const syncOpus = () => {
    clearTimeout(opusTimer);
    opusTimer = setTimeout(() => {
      try {
        if (typeof window.opusRefreshCart === 'function') window.opusRefreshCart();
      } catch (e) {
        /* App-Fehler ignorieren */
      }
    }, 300);
  };

  /* Fremde Änderungen (EGO-Gratisartikel, andere Apps, anderer Tab) nachziehen */
  let externalTimer;
  const syncExternal = () => {
    clearTimeout(externalTimer);
    externalTimer = setTimeout(() => {
      enqueue(async () => {
        const cart = await fetchCart();
        if (signature(cart) !== state.sig) {
          setCart(cart);
          document.dispatchEvent(new CustomEvent('gcs:cart:updated', { detail: { cart, source: 'external' } }));
        } else {
          state.cart = cart;
        }
        return cart;
      }).catch(() => {});
    }, 350);
  };

  /* 6 Öffentliche API ----------------------------------------------------------------------------- */
  const normalize = (items) =>
    (Array.isArray(items) ? items : [items])
      .filter(Boolean)
      .map((item) => {
        const line = { id: Number(item.id), quantity: Math.max(1, parseInt(item.quantity, 10) || 1) };
        if (item.properties) line.properties = item.properties;
        if (item.selling_plan) line.selling_plan = item.selling_plan;
        return line;
      })
      .filter((line) => line.id > 0);

  const drawerEl = () => document.getElementById('GcsCartDrawer');

  const api = {
    __gcsCart: true,
    sources: SOURCES,

    get state() {
      return state.cart;
    },

    get() {
      return enqueue(async () => {
        const cart = await fetchCart();
        setCart(cart);
        return cart;
      });
    },

    refresh() {
      return api.get();
    },

    add(items, { source = 'pdp', open = true } = {}) {
      const list = normalize(items);
      if (!list.length) return Promise.reject(new Error('Bitte wähle zuerst eine Größe.'));
      return enqueue(async () => {
        try {
          const response = await post('cart/add.js', { items: list, sections: META_SECTION });
          if (response && response.sections) readMetaHTML(response.sections[META_SECTION]);
          const added = response && Array.isArray(response.items) ? response.items : [];
          rememberAdded(added[0]);
          const cart = await fetchCart();
          emit(cart, source, list[0].id, { added: added.map((i) => i.key) });
          if (open) api.open({ refresh: false });
          syncOpus();
          return cart;
        } catch (error) {
          return fail(error, source);
        }
      });
    },

    change(key, quantity, { source = 'drawer' } = {}) {
      const qty = Math.max(0, parseInt(quantity, 10) || 0);
      const isLine = typeof key === 'number' && key > 0 && key < 1000;
      const body = isLine ? { line: key, quantity: qty } : { id: String(key), quantity: qty };
      const variantId = isLine ? undefined : Number(String(key).split(':')[0]) || undefined;
      return enqueue(async () => {
        try {
          await post('cart/change.js', body);
          const cart = await fetchCart();
          emit(cart, source, variantId);
          syncOpus();
          return cart;
        } catch (error) {
          syncExternal(); // Anzeige auf den echten Stand bringen (z. B. Position inzwischen woanders geändert)
          return fail(error, source);
        }
      });
    },

    open(options = {}) {
      const drawer = drawerEl();
      if (drawer && typeof drawer.show === 'function') {
        drawer.show(options);
        return;
      }
      window.location.href = routes().cart;
    },

    close() {
      const drawer = drawerEl();
      if (drawer && typeof drawer.close === 'function') drawer.close();
    },

    isOpen() {
      const drawer = drawerEl();
      return !!(drawer && drawer.isOpen);
    },
  };
  GCS.cart = api;

  /* 7 Empfehlungen -------------------------------------------------------------------------------- */
  const recCache = new Map();
  const loadRecs = (productId) => {
    if (recCache.has(productId)) return recCache.get(productId);
    const get = (intent) =>
      window
        .fetch(`${root()}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=${intent}`, {
          headers: { Accept: 'application/json' },
        })
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => (d && Array.isArray(d.products) ? d.products : []))
        .catch(() => []);
    const request = (async () => {
      let list = await get('complementary');
      if (list.length < 4) {
        const related = await get('related');
        list = list.concat(related.filter((r) => !list.some((x) => x.id === r.id)));
      }
      return list;
    })();
    recCache.set(productId, request);
    return request;
  };
  const usableRec = (product, inCart) => {
    if (!product || inCart.has(product.id)) return false;
    if (product.available === false || !(product.variants || []).some((v) => v.available)) return false;
    if (!(product.price > 0)) return false;
    if (/gratis/i.test(product.title || '')) return false;
    if ((product.tags || []).some((t) => /versand gratis socken/i.test(t))) return false;
    if (product.vendor === 'Planet' || product.type === 'PLANET_CONTRIBUTION') return false;
    return true;
  };
  /* Vorbestellung bei Empfehlungen (Abschluss Impeccable, 02.10.2026): Live markiert die App „Preorder Now Wolf“
     Vorbestellungs-Varianten mit properties[Typ]=Vorbestellung (Fulfillment-Kennzeichnung, kein Selling Plan); PDP und
     Schnellkauf schicken das mit. /recommendations/products.json kennt weder Bestand noch „weiter verkaufen“, deshalb
     holen wir die Flags je Variante per Section Rendering aus gcs-quick-add-sheet (Liquid-Regel Bauvertrag 4, Cache
     geteilt mit dem Schnellkauf über GCS.quickAdd.variants). Die Inline-Größenwahl bleibt (das Sheet würde den Drawer
     schließen, GcsDrawer lässt nur einen offenen Drawer zu). Fällt der Abruf aus, gilt die Produkt-Regel aus dem JSON
     (Tag „preorder“, „VORBESTELLUNG“ im Titel). Gleiche Konstante wie in gcs-quick-add.js. */
  const PREORDER_PROPERTIES = { Typ: 'Vorbestellung' };
  // Position mit Vorbestellungs-Eigenschaft (Runde D: Hinweis über der Kasse, Badge an der Zeile)
  const isPreorderLine = (item) =>
    !!(item && item.properties && Object.keys(PREORDER_PROPERTIES).every((k) => item.properties[k] === PREORDER_PROPERTIES[k]));
  const productPreorder = (p) => !!p && ((p.tags || []).indexOf('preorder') > -1 || /vorbestellung/i.test(p.title || ''));
  const flagCache = new Map();
  const productCache = new Map();
  const recFlags = (product) => {
    const id = String(product.id);
    if (flagCache.has(id)) return flagCache.get(id);
    const qa = GCS.quickAdd;
    const url = product.url || `${root()}products/${product.handle}`;
    const request = (qa && typeof qa.variants === 'function' ? qa.variants(url) : Promise.reject(new Error('quick-add')))
      .then((list) => new Map((list || []).map((v) => [String(v.id), v])))
      .catch(() => {
        flagCache.delete(id);
        return null;
      });
    flagCache.set(id, request);
    return request;
  };
  const recPreorder = (flags, product, variantId) => {
    const v = flags && flags.get(String(variantId));
    return v ? !!v.preorder : productPreorder(product);
  };

  /* Nur reguläre Produkte (Runde D, Korrektur David 04.10.2026): Tag „socken“ oder „underwear“ = kanonische
     Navigations-Produkte (docs/kategorien-mapping.md). So tauchen keine Dubletten (z. B. „KLASSIKER HIGH“,
     aduld-pack), Kombis oder Bundles auf. Weniger als 3 übrig → mit Bestsellern (Collection „bestseller“, sonst
     „socken“) auffüllen, höchstens 4 Karten. */
  const REC_TAGS = ['socken', 'underwear'];
  const regularRec = (p) => (p.tags || []).some((t) => REC_TAGS.indexOf(String(t).trim().toLowerCase()) > -1);
  const REC_MAX = 4;
  const REC_MIN = 3;
  /* /collections/<handle>/products.json (Preise als Text) → Format von /products/<handle>.js (Cent) */
  const fromCollectionJson = (p) => {
    const cents = (v) => (v == null || v === '' ? null : Math.round(parseFloat(v) * 100) || 0);
    const variants = (p.variants || []).map((v) => ({ id: v.id, title: v.title, available: v.available !== false, price: cents(v.price) || 0, compare_at_price: cents(v.compare_at_price) }));
    const prices = variants.map((v) => v.price).filter((x) => x > 0);
    const min = prices.length ? Math.min.apply(null, prices) : 0;
    const max = prices.length ? Math.max.apply(null, prices) : 0;
    const cheapest = variants.find((v) => v.price === min) || {};
    const images = (p.images || []).map((i) => i && i.src).filter(Boolean);
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      url: `${root()}products/${p.handle}`,
      type: p.product_type || '',
      vendor: p.vendor,
      tags: p.tags || [],
      description: p.body_html || '',
      options: p.options || [],
      variants,
      available: variants.some((v) => v.available),
      price: min,
      price_min: min,
      price_max: max,
      price_varies: min !== max,
      compare_at_price: cheapest.compare_at_price || null,
      images,
      featured_image: images[0] || '',
    };
  };
  let fillRequest = null;
  const loadFill = () => {
    if (fillRequest) return fillRequest;
    const get = (handle) =>
      window
        .fetch(`${root()}collections/${handle}/products.json?limit=24`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => (d && Array.isArray(d.products) ? d.products.map(fromCollectionJson) : []))
        .catch(() => []);
    fillRequest = get('bestseller').then((list) => (list.length ? list : get('socken')));
    return fillRequest;
  };
  /* Black Month (Nico 31.10.2026): Solange GCS.settings.salePercent > 0 ist, kommen die Empfehlungen aus der
     Kategorie des zuletzt gelegten Produkts (Sport, Colors, High, Mid, Low, Junior, Underwear). Die Collections sind
     im Admin manuell nach Bestand sortiert, products.json liefert diese Reihenfolge. Auffüllen aus „socken“. */
  const SALE_CATS = { high: 'socken-high', mid: 'socken-mid', low: 'socken-low', junior: 'socken-junior', underwear: 'underwear' };
  const collectionCache = new Map();
  const loadCollection = (handle) => {
    if (collectionCache.has(handle)) return collectionCache.get(handle);
    const request = window
      .fetch(`${root()}collections/${handle}/products.json?limit=24`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((d) => (d && Array.isArray(d.products) ? d.products.map(fromCollectionJson) : []))
      .catch(() => []);
    collectionCache.set(handle, request);
    return request;
  };
  const saleCategory = async (item) => {
    let tags = [];
    try {
      const p = await window.fetch(`${root()}products/${item.handle}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : {}));
      tags = (p.tags || []).map((t) => String(t).trim().toLowerCase());
    } catch (e) {
      tags = [];
    }
    if (tags.indexOf('sport') > -1) return 'socken-sport';
    if (tags.indexOf('farbig') > -1) return 'socken-colors';
    return SALE_CATS[String(item.product_type || '').trim().toLowerCase()] || 'socken';
  };
  const recommendationsFor = async (cart) => {
    const items = (cart.items || []).filter((i) => !isGift(i));
    if (!items.length) return [];
    const last = state.lastAdded && items.find((i) => i.product_id === state.lastAdded.productId);
    const seed = (last || items[0]).product_id;
    const inCart = new Set((cart.items || []).map((i) => i.product_id));
    const ok = (p) => usableRec(p, inCart) && regularRec(p);
    const sale = Number(settings().salePercent) > 0;
    const source = sale ? await loadCollection(await saleCategory(last || items[0])) : await loadRecs(seed);
    const recs = source.filter(ok).slice(0, REC_MAX);
    if (recs.length < REC_MIN) {
      (sale ? await loadCollection('socken') : await loadFill()).forEach((p) => {
        if (recs.length < REC_MAX && ok(p) && !recs.some((r) => r.id === p.id)) recs.push(p);
      });
    }
    return recs;
  };

  /* 8 Markup (identisch zu den Liquid-Snippets gcs-cart-line, gcs-cart-totals, gcs-cart-reward) ------ */
  /* Mengenrabatt-Hinweis (Impeccable G8, Runde D 04.10.2026): Kaching rabattiert pro Produkt über alle Größen. Packs
     desselben Produkts über alle Positionen zählen (ohne Gratisartikel), nächste Stufe mit höherem Prozentsatz aus
     GCS.settings.packTiers (nur Anzeige der Stufe, Beträge aus /cart.js). Hinweis an JEDER Position des Produkts
     (bis 03.10. nur an der letzten Position: Bug „+1 Pack nur bei einer Position“), „+1 Pack“ erhöht die jeweilige
     Position. Ab der höchsten Stufe kein Hinweis. Gleiche Regel wie snippets/gcs-cart-line.liquid. */
  const productTotals = (cart) => {
    const totals = {};
    (cart.items || []).forEach((item) => {
      if (!(item.final_price > 0) || isGift(item)) return;
      totals[item.product_id] = (totals[item.product_id] || 0) + item.quantity;
    });
    return totals;
  };
  const nudgeFor = (item, totals, m) => {
    const s = settings();
    if (s.discountSingle !== false || s.cartNudge === false || Number(s.salePercent) > 0 || !m || !m.tier || isGift(item) || !(item.final_price > 0)) return '';
    const qty = (totals && totals[item.product_id]) || 0;
    if (!qty) return '';
    const tiers = s.packTiers || {};
    const steps = Object.keys(tiers)
      .map(Number)
      .filter((n) => n > 1 && Number(tiers[n]) > 0)
      .sort((x, y) => x - y);
    const current = steps.filter((n) => n <= qty).reduce((max, n) => Math.max(max, Number(tiers[n]) || 0), 0);
    const next = steps.find((n) => n > qty && Number(tiers[n]) > current);
    if (!next) return '';
    const texts = s.texts || {};
    const text = String(texts.cartNudge || 'Mit [packs] Packs davon: −[percent] %')
      .replace('[packs]', String(next))
      .replace('[percent]', String(tiers[next]).replace('.', ','));
    return { text, button: String(texts.cartNudgeButton || '+1 Pack') };
  };

  /* BF-Sale 2026: Solange GCS.settings.salePercent > 0 ist, liefern nudgeFor() und dealFor() nichts. Der Plus-Button
     ist dann ein reiner Mengen-Button ohne Rabatt-Hinweis (Mengenrabatte sind während der Aktion aus). */
  /* Review PR #4 (David, 16.10.2026): Rabatt am Plus-Button, gleiche Regel wie snippets/gcs-cart-line.liquid (l_deal_pct).
     Bringt ein weiteres Pack DIESES Produkts (Packs über alle Größen, wie Kaching rechnet) die nächste Stufe,
     liefert dealFor() deren Prozentwert, sonst ''. */
  const dealFor = (item, totals, m) => {
    const s = settings();
    if (s.discountSingle === false || s.cartNudge === false || Number(s.salePercent) > 0 || !m || !m.tier || isGift(item) || !(item.final_price > 0)) return '';
    const qty = (totals && totals[item.product_id]) || 0;
    if (!qty || qty >= 4) return '';
    const tiers = s.packTiers || {};
    const pct = (n) => Number(tiers[n]) || 0;
    let cur = 0;
    for (let n = 2; n <= 4; n++) if (n <= qty) cur = Math.max(cur, pct(n));
    return pct(qty + 1) > cur ? String(pct(qty + 1)).replace('.', ',') : '';
  };

  const renderLine = (item, index, context, totals) => {
    const m = meta.get(String(item.variant_id));
    const title = cleanTitle(item.product_title);
    const free = item.final_line_price === 0;
    const gift = isGift(item);
    const change = `${routes().cartChange}?line=${index}&quantity=`;
    const qty = item.quantity;
    const variant = item.product_has_only_default_variant ? '' : variantText(item.options_with_values);
    // Runde D: Vorbestellung auch über die Eigenschaft „Typ: Vorbestellung“; die Eigenschaft selbst nicht doppelt zeigen
    const preProp = isPreorderLine(item);
    const preorder = !!(m && m.preorder) || preProp;
    const preText = preorder
      ? String((m && m.preorderText) || (settings().texts || {}).preorder || 'Vorbestellung: Versand sobald verfügbar').replace(/^Vorbestellung:\s*/, '')
      : '';
    const props = Object.keys(item.properties || {})
      .filter((k) => k.charAt(0) !== '_' && item.properties[k] !== '' && item.properties[k] != null)
      .filter((k) => !(preProp && Object.prototype.hasOwnProperty.call(PREORDER_PROPERTIES, k)))
      .map((k) => `<p class="gcs-line__prop">${esc(k)}: ${esc(item.properties[k])}</p>`)
      .join('');
    const image = item.image
      ? `<img src="${esc(imgUrl(item.image, 200))}" srcset="${esc(imgUrl(item.image, 100))} 100w, ${esc(imgUrl(item.image, 200))} 200w" sizes="100px" alt="" class="gcs-line__img" width="100" height="100" loading="lazy">`
      : '<span class="gcs-line__img gcs-placeholder"></span>';
    const qtyValue =
      context === 'page'
        ? `<input class="gcs-qty__input" type="number" inputmode="numeric" name="updates[${esc(item.key)}]" value="${qty}" min="0" aria-label="Menge ${esc(title)}" data-gcs-qty-input>`
        : `<span class="gcs-qty__val" data-gcs-qty-val>${qty}</span>`;
    const dec =
      qty > 1
        ? `<a class="gcs-qty__btn" href="${change}${qty - 1}" role="button" data-gcs-qty="-1" aria-label="Menge verringern">${icon('minus', 16)}</a>`
        : `<a class="gcs-qty__btn" role="button" data-gcs-qty="-1" aria-disabled="true" aria-label="Menge verringern">${icon('minus', 16)}</a>`;
    const deal = gift ? '' : dealFor(item, totals, m);
    const controls = gift
      ? `<span class="gcs-line__gift">${icon('gift', 16)}Geschenk</span>`
      : `<div class="gcs-qty" role="group" aria-label="Menge">${dec}${qtyValue}<a class="gcs-qty__btn${deal ? ' gcs-qty__btn--deal' : ''}" href="${change}${qty + 1}" role="button" data-gcs-qty="1" aria-label="Menge erhöhen${deal ? `, dann ${deal} % Mengenrabatt` : ''}">${icon('plus', 16)}${deal ? `<span class="gcs-qty__deal" aria-hidden="true">−${deal}&nbsp;%</span>` : ''}</a></div>`;
    const discounts =
      !free && settings().discountSingle === false && (item.line_level_discount_allocations || []).length
        ? `<ul class="gcs-line__discounts" role="list">${item.line_level_discount_allocations
            .map(
              (a) =>
                `<li>${icon('tag', 14)}<span>${esc((a.discount_application && (a.discount_application.title || a.discount_application.description)) || 'Rabatt')}</span><span class="gcs-nowrap">−${money(a.amount)}</span></li>`
            )
            .join('')}</ul>`
        : '';
    const nudge = nudgeFor(item, totals, m);
    return `<li class="gcs-line${free ? ' is-free' : ''}" data-gcs-line data-key="${esc(item.key)}" data-line="${index}" data-qty="${qty}" data-variant-id="${item.variant_id}">
  <a class="gcs-line__media" href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${image}</a>
  <div class="gcs-line__info">
    <div class="gcs-line__head">
      <a class="gcs-line__title" href="${esc(item.url)}">${esc(title)}</a>
      <a class="gcs-line__remove" href="${change}0" role="button" data-gcs-remove aria-label="${esc(title)} entfernen">${icon('trash', 18)}</a>
    </div>
    ${variant ? `<p class="gcs-line__variant">${variant}</p>` : ''}
    ${preorder ? `<p class="gcs-line__pre"><span class="gcs-badge gcs-badge--line">Vorbestellung</span> <span>${esc(preText)}</span></p>` : ''}
    ${props}
    <div class="gcs-line__foot">
      ${controls}
      <div class="gcs-line__price" data-gcs-line-price>${
        item.original_line_price > item.final_line_price ? `<s class="gcs-line__was"><span class="gcs-sr">Statt </span>${money(item.original_line_price)}</s>` : ''
      }<span class="gcs-line__now">${free ? 'Gratis' : money(item.final_line_price)}</span></div>
    </div>
    ${discounts}
  </div>
  ${
    nudge
      ? `<div class="gcs-line__nudge" data-gcs-nudge><p class="gcs-line__nudge-text">${icon('tag', 14)}<span>${esc(nudge.text)}</span></p><a class="gcs-line__nudge-btn" href="${change}${qty + 1}" role="button" data-gcs-qty="1" data-gcs-nudge-add aria-label="${esc(nudge.button)}: ${esc(title)}">${esc(nudge.button)}</a></div>`
      : ''
  }
</li>`;
  };

  /* A7 (15.10.2026): mit discountSingle (Standard) Ersparnis EINMAL als Zeile bei der Zwischensumme, gleich wie
     snippets/gcs-cart-totals.liquid: Zwischensumme = original_total_price, Du sparst = total_discount, Gesamt = total_price. */
  const renderTotalsSingle = (cart, taxesIncluded) => `<dl class="gcs-totals__list">
    <div class="gcs-totals__row"><dt>Zwischensumme</dt><dd>${money(cart.original_total_price)}</dd></div>
    ${
      cart.total_discount > 0
        ? `<div class="gcs-totals__row gcs-totals__row--save"><dt>${esc((settings().texts || {}).cartSaveLabel || 'Du sparst')}</dt><dd>−${money(cart.total_discount)}</dd></div>`
        : ''
    }
    <div class="gcs-totals__row gcs-totals__row--total"><dt>Gesamt</dt><dd data-gcs-cart-total>${money(cart.total_price)}</dd></div>
  </dl>
  <p class="gcs-totals__note">${taxesIncluded ? 'Inkl. MwSt., Versand wird an der Kasse berechnet.' : 'Versand und Steuern werden an der Kasse berechnet.'}</p>`;
  const renderTotals = (cart, taxesIncluded) => (settings().discountSingle !== false ? renderTotalsSingle(cart, taxesIncluded) : renderTotalsLegacy(cart, taxesIncluded));
  const renderTotalsLegacy = (cart, taxesIncluded) => `<dl class="gcs-totals__list">
    <div class="gcs-totals__row"><dt>Zwischensumme</dt><dd>${money(cart.items_subtotal_price)}</dd></div>
    ${(cart.cart_level_discount_applications || [])
      .map(
        (a) =>
          `<div class="gcs-totals__row gcs-totals__row--discount"><dt>${icon('tag', 14)}${esc(a.title || a.description || 'Rabatt')}</dt><dd>−${money(a.total_allocated_amount)}</dd></div>`
      )
      .join('')}
    <div class="gcs-totals__row gcs-totals__row--total"><dt>Gesamt</dt><dd data-gcs-cart-total>${money(cart.total_price)}</dd></div>
  </dl>
  ${cart.total_discount > 0 ? `<p class="gcs-totals__save">Du sparst ${money(cart.total_discount)}</p>` : ''}
  <p class="gcs-totals__note">${taxesIncluded ? 'Inkl. MwSt., Versand wird an der Kasse berechnet.' : 'Versand und Steuern werden an der Kasse berechnet.'}</p>`;

  /* Lieferzeile bzw. Vorbestellungs-Hinweis (Runde D, 04.10.2026), gleiches Markup wie snippets/gcs-cart-delivery.liquid.
     Sobald eine Position properties.Typ === 'Vorbestellung' trägt (PREORDER_PROPERTIES, wie die App „Preorder Now Wolf“),
     ersetzt der Hinweis die Lieferzeile und nennt jede vorbestellte Position „Produkt · Größe“ mit Text aus den
     Theme-Settings (Frist aus dem Titel über meta.frist). Keine Aussage zu Teil- oder Gesamtlieferung. */
  const renderDelivery = (cart) => {
    const texts = settings().texts || {};
    const pre = (cart.items || []).filter(isPreorderLine);
    if (!pre.length) {
      return `<p class="gcs-cart__delivery">${icon('truck', 18)}<span>${esc(texts.delivery || 'Versand innerhalb von 1–3 Werktagen')}</span></p>`;
    }
    const list = pre
      .map((item) => {
        const m = meta.get(String(item.variant_id));
        const frist = m && m.frist ? String(m.frist) : '';
        const note = frist
          ? String(texts.cartPreorderItemFrist || 'Lieferzeit [frist]').replace('[frist]', frist)
          : String(texts.cartPreorderItem || 'wird versendet, sobald verfügbar');
        const size = item.product_has_only_default_variant ? '' : (item.options_with_values || []).map((o) => optionValue(o.value)).join(' · ');
        return `<li><span class="gcs-cart__pre-name">${esc(cleanTitle(item.product_title))}${size ? ` · ${esc(size)}` : ''}</span> <span class="gcs-cart__pre-note">${esc(note)}</span></li>`;
      })
      .join('');
    return `<div class="gcs-cart__pre"><p class="gcs-cart__pre-head"><span class="gcs-cart__pre-icon">${icon('clock', 18)}</span><span>${esc(
      texts.cartPreorderHeading || 'Vorbestellung im Warenkorb'
    )}</span></p><ul class="gcs-cart__pre-list" role="list">${list}</ul></div>`;
  };

  const rewardTiers = () => {
    const s = settings();
    const country = String(s.country || '').toUpperCase();
    const localOk = (s.freeShippingCountries || []).map((c) => String(c).trim().toUpperCase()).indexOf(country) > -1;
    const rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return (s.rewards || [])
      .filter((r) => r && r.enabled && Number(r.threshold) > 0 && r.label && (!r.local || localOk))
      .map((r) => ({ label: String(r.label), cents: Math.round(Number(r.threshold) * 100 * rate) }))
      .sort((a, b) => a.cents - b.cents);
  };
  const tierIcon = (label) => {
    const l = label.toLowerCase();
    if (l.indexOf('versand') > -1) return 'truck';
    if (l.indexOf('pack') > -1 || l.indexOf('geschenk') > -1 || l.indexOf('gratis') > -1) return 'gift';
    return 'tag';
  };
  /* Basis je Stufe: Versand-Stufen nach allen Rabatten (cart.total_price, so prüft Shopify die Versandrate),
     Rabatt- und Geschenk-Stufen vor Warenkorb-Rabatten (cart.items_subtotal_price), damit z. B. „10 € Rabatt ab 100 €“
     nicht wieder als offen gilt, sobald Shopify die 10 € abzieht. */
  const tierBase = (cart, tier) => (tierIcon(tier.label) === 'truck' ? cart.total_price : cart.items_subtotal_price);
  /* A5 (Review-Call 08.10., 15.10.2026): eine Zeile zur nächsten offenen Stufe, ehrliche Leiste (Füllung endet vor dem
     Symbol der nächsten offenen Stufe). Gleiche Regel wie snippets/gcs-cart-reward.liquid. */
  const rewardMessage = (tiers, next, cart) => {
    const texts = settings().texts || {};
    const shipReached = tiers.some((t) => t.ship && t.reached);
    const fill = (tpl, rest, label) =>
      esc(tpl)
        .split('[betrag]')
        .join(`<strong>${money(rest)}</strong>`)
        .split('[stufe]')
        .join(esc(label || ''));
    if (next && next.ship) return { html: fill(texts.cartShip || 'Noch [betrag] bis zum Gratisversand', next.cents - tierBase(cart, next)), done: false };
    if (shipReached) return { html: esc(texts.cartShipDone || 'Gratisversand ist dabei'), done: true };
    if (next) return { html: fill(texts.cartRewardNext || 'Noch [betrag] bis [stufe]', next.cents - tierBase(cart, next), next.label), done: false };
    const reached = tiers.filter((t) => t.reached).pop();
    return reached ? { html: `${esc(reached.label)} freigeschaltet`, done: true } : null;
  };
  /* Black Month (Review-Call 24.10.2026): nur ein Ziel (Gratisversand), Text mit Ersparnis aus /cart.js
     (cart.total_discount, gleiche Zahl wie „Du sparst“). Gleiche Regel wie snippets/gcs-cart-reward-bf.liquid,
     Schwelle/Land/Text kommen aus den data-gcs-bf-*-Attributen am Reward-Element (nur im BF-Snippet gesetzt). */
  const bfReward = (el) => {
    if (!el || !el.hasAttribute('data-gcs-bf')) return null;
    const rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return {
      cents: Math.round((Number(el.getAttribute('data-gcs-bf-threshold')) || 0) * 100 * rate),
      local: el.getAttribute('data-gcs-bf-local') === 'true',
      savedText: el.getAttribute('data-gcs-bf-saved') || 'Schon [betrag] gespart',
    };
  };
  const renderRewardBf = (cart, bf) => {
    if (!cart || !cart.item_count) return '';
    const texts = settings().texts || {};
    const amount = (tpl, cents) => esc(tpl).split('[betrag]').join(`<strong>${money(cents)}</strong>`);
    const saved = Number(cart.total_discount) || 0;
    const savedHtml = saved > 0 ? amount(bf.savedText, saved) : '';
    const bar = bf.local && bf.cents > 0;
    const msgP = (html, done) =>
      `<div class="gcs-reward__msgs" aria-live="polite"><p class="gcs-reward__msg${done ? ' gcs-reward__msg--done' : ''}">${done ? icon('check', 16) : ''}<span>${html}</span></p></div>`;
    if (!bar) return savedHtml ? msgP(savedHtml, false) : '';
    const total = Number(cart.total_price) || 0;
    const reached = total >= bf.cents;
    let html;
    if (reached) {
      const doneText = esc(texts.cartShipDone || 'Gratisversand ist dabei');
      html = savedHtml ? `${savedHtml} · ${doneText}` : doneText;
    } else {
      html = savedHtml || amount(texts.cartShip || 'Noch [betrag] bis zum Gratisversand', bf.cents - total);
    }
    const fill = Math.min(100, Math.floor((total * 100) / bf.cents));
    const gap = !reached && settings().rewardHonest !== false ? '18px' : '0px';
    const euros = money(bf.cents).replace(/,00(?= )/, '');
    return `${msgP(html, reached)}
    <div class="gcs-reward__track" role="progressbar" aria-label="Fortschritt bis zum Gratisversand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${fill}"><span class="gcs-reward__rail" style="--gcs-cap: 1; --gcs-cap-gap: ${gap}"><span class="gcs-reward__fill" style="--gcs-fill: ${fill / 100}"></span></span><span class="gcs-reward__tick${
      reached ? ' is-reached' : ''
    }" style="--gcs-tick: 100%" title="Gratisversand ab ${esc(euros)}">${icon('truck', 14)}</span></div>
    <div class="gcs-reward__labels" aria-hidden="true"><span class="gcs-reward__label is-end${reached ? ' is-reached' : ''}" style="--gcs-tick: 100%">Gratisversand</span></div>`;
  };
  const renderReward = (cart, el) => {
    const bf = bfReward(el);
    /* BF-Leiste wie im Liquid nur bei EUR (gcs-cart-reward-bf.liquid) */
    if (bf) return cart.currency && cart.currency !== 'EUR' ? '' : renderRewardBf(cart, bf);
    const tiers = rewardTiers();
    if (!tiers.length || !cart.item_count) return '';
    const last = tiers[tiers.length - 1].cents;
    let progress = cart.total_price;
    let next = null;
    tiers.forEach((t) => {
      t.ship = tierIcon(t.label) === 'truck';
      t.reached = tierBase(cart, t) >= t.cents;
      if (t.reached) {
        progress = Math.max(progress, t.cents);
      } else if (!next) {
        next = t;
      }
    });
    const fill = Math.min(100, Math.floor((progress * 100) / last));
    const honest = settings().rewardHonest !== false && next;
    const cap = honest ? Math.floor((next.cents * 100) / last) / 100 : 1;
    const gap = honest ? '18px' : '0px';
    const msg = rewardMessage(tiers, next, cart);
    const ticks = tiers
      .map((t) => {
        const pos = Math.floor((t.cents * 100) / last);
        const euros = money(t.cents).replace(/,00(?=\u00a0)/, '');
        return `<span class="gcs-reward__tick${t.reached ? ' is-reached' : ''}" style="--gcs-tick: ${pos}%" title="${esc(t.label)} ab ${esc(euros)}">${icon(tierIcon(t.label), 14)}</span>`;
      })
      .join('');
    // Beschriftung je Stufe (Impeccable G8e): Label unter dem Symbol, am Rand bündig
    const labels = tiers
      .map((t) => {
        const pos = Math.floor((t.cents * 100) / last);
        const align = pos >= 85 ? ' is-end' : pos <= 15 ? ' is-start' : '';
        return `<span class="gcs-reward__label${align}${t.reached ? ' is-reached' : ''}" style="--gcs-tick: ${pos}%">${esc(t.label)}</span>`;
      })
      .join('');
    return `<div class="gcs-reward__msgs" aria-live="polite">${
      msg ? `<p class="gcs-reward__msg${msg.done ? ' gcs-reward__msg--done' : ''}">${msg.done ? icon('check', 16) : ''}<span>${msg.html}</span></p>` : ''
    }</div>
    <div class="gcs-reward__track" role="progressbar" aria-label="Fortschritt bis zum nächsten Vorteil" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${fill}"><span class="gcs-reward__rail" style="--gcs-cap: ${cap}; --gcs-cap-gap: ${gap}"><span class="gcs-reward__fill" style="--gcs-fill: ${fill / 100}"></span></span>${ticks}</div>
    <div class="gcs-reward__labels" aria-hidden="true">${labels}</div>`;
  };

  const variantLabel = (v) =>
    String(v.title || '')
      .split(' / ')
      .map(optionValue)
      .join(' · ');

  /* Mini-Produktkarte (Runde D, 04.10.2026): gleiches Markup wie snippets/gcs-mini-card.liquid, Doku
     docs/architecture/mini-card.md. Produkt-JSON aus /recommendations/products.json oder /products/<handle>.js
     (Preise in Cent). add: 'inline' (Warenkorb: Größenwahl in der Karte über CartView), 'quick' (data-gcs-quick-add,
     gcs-quick-add.js: eine Variante direkt, sonst Schnellkauf-Sheet) oder 'none'. Öffentlich: GCS.miniCard.html(). */
  const renderMiniPrice = (p) => {
    const pairs = pairsForProduct(p);
    const varies = p.price_varies || (p.price_min && p.price_max && p.price_min !== p.price_max);
    let now = p.price;
    let was = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : 0;
    /* BF-Sale 2026: mit GCS.settings.salePercent > 0 Aktionspreis (GCS.salePrice, wie snippets/gcs-price.liquid),
       durchgestrichen der normale Preis. Gutscheine ohne Rabatt. */
    const salePct = Number(settings().salePercent) || 0;
    const saleExcluded = (settings().saleExcludeHandles || []).indexOf(p.handle) > -1;
    if (salePct > 0 && !saleExcluded && now > 0 && !p.gift_card && String(p.type || p.product_type || '').toLowerCase() !== 'gift card' && window.GCS.salePrice) {
      was = now;
      now = window.GCS.salePrice(now);
    }
    return `<div class="gcs-price gcs-price--s${was ? ' gcs-price--sale' : ''} gcs-mini-card__price" data-gcs-price><span class="gcs-price__now" data-gcs-price-now>${
      was ? '<span class="gcs-sr">Angebotspreis </span>' : ''
    }${varies ? 'ab ' : ''}${money(now)}</span>${
      was ? `<s class="gcs-price__was" data-gcs-price-was><span class="gcs-sr">Normalpreis </span>${money(was)}</s>` : ''
    }${
      was && salePct > 0 && !saleExcluded ? `<span class="gcs-price__off" aria-hidden="true">−${salePct}&nbsp;%</span>` : ''
    }${pairs ? `<span class="gcs-price__pp" data-gcs-price-pp data-pairs="${pairs}">${money(Math.round(now / pairs))} pro Paar</span>` : ''}</div>`;
  };
  const MINI_WIDTHS = [64, 80, 128, 160, 240];
  const renderMiniCard = (p, { size = 'compact', add = 'inline', tag = 'div', kind = '', className = '' } = {}) => {
    const large = size === 'large';
    const title = cleanTitle(p.title);
    const variants = p.variants || [];
    // Direkt in den Warenkorb nur bei genau einer Variante (Bauvertrag 4), sonst immer Größe wählen lassen
    const single = variants.length === 1 && variants[0].available ? variants[0] : null;
    const url = p.url || `${root()}products/${p.handle}`;
    const images = (p.images || []).map((i) => (typeof i === 'string' ? i : i && i.src)).filter(Boolean);
    let src = (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image && p.featured_image.src) || images[0] || '';
    if ((p.tags || []).indexOf('pdp-hide-first-image') > -1 && images.length > 1) src = images[1];
    const soldout = p.available === false || (variants.length > 0 && !variants.some((v) => v.available));
    const dim = large ? 80 : 64;
    const image = src
      ? `<img src="${esc(imgUrl(src, 240))}" srcset="${MINI_WIDTHS.map((w) => `${esc(imgUrl(src, w))} ${w}w`).join(', ')}" sizes="${
          large ? '(min-width: 990px) 80px, 72px' : '64px'
        }" width="${dim}" height="${dim}" loading="lazy" fetchpriority="low" decoding="async" alt="" class="gcs-mini-card__img">`
      : '<span class="gcs-placeholder gcs-mini-card__img"></span>';
    const label = `${esc(title)} in den Warenkorb`;
    let button = '';
    if (!soldout && add === 'quick') {
      button = `<button type="button" class="gcs-mini-card__add" data-gcs-quick-add data-product-handle="${esc(p.handle)}" data-product-url="${esc(url)}"${
        single ? ` data-variant-id="${single.id}"${productPreorder(p) ? ' data-variant-preorder' : ''}` : ''
      } aria-label="${label}">${icon('plus', 22)}</button>`;
    } else if (!soldout && add !== 'none') {
      button = `<button type="button" class="gcs-mini-card__add" data-gcs-mini-add${single ? ` data-variant-id="${single.id}"` : ' aria-expanded="false"'} aria-label="${label}">${icon(
        'plus',
        22
      )}</button><div class="gcs-mini-card__picker" data-gcs-mini-picker hidden></div>`;
    }
    const el = tag === 'li' ? 'li' : 'div';
    return `<${el} class="gcs-mini-card gcs-mini-card--${large ? 'large' : 'compact'}${soldout ? ' is-soldout' : ''}${className ? ` ${esc(className)}` : ''}" data-product-id="${p.id}" data-product-handle="${esc(
      p.handle
    )}"${kind ? ` data-kind="${esc(kind)}"` : ''}>
  <a class="gcs-mini-card__link" href="${esc(url)}"><span class="gcs-mini-card__media">${image}</span><span class="gcs-mini-card__info"><span class="gcs-mini-card__title">${esc(
      title
    )}</span>${renderMiniPrice(p)}</span></a>
  ${button}
</${el}>`;
  };
  GCS.miniCard = {
    html: (product, options = {}) => (product ? renderMiniCard(product, Object.assign({ add: 'quick' }, options)) : ''),
  };

  /* 9 CartView: gemeinsame Logik für Drawer und Seite /cart ---------------------------------------- */
  class CartView {
    constructor(el, context) {
      this.el = el;
      this.context = context;
      this.source = context === 'page' ? 'cart-page' : 'drawer';
      // Liquid rendert die Reward-Bar nur in EUR; in anderen Währungen rendert JS beim ersten Stand neu.
      const active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      this.sig = !active || active === 'EUR' ? el.getAttribute('data-gcs-sig') : null;
      this.taxesIncluded = el.getAttribute('data-taxes-included') !== 'false';
      this.pending = new Map();
      this.timers = new Map();
      this.recIds = '';
      this.recProducts = new Map();
      this.errorTimer = null;
      el.addEventListener('click', (e) => this.onClick(e));
      el.addEventListener('change', (e) => this.onChange(e));
      el.addEventListener('submit', (e) => this.onSubmit(e));
      // Vorbestellungs-Flags der Empfehlung vorladen (Maus-Hover, Touch-Beginn, Tastaturfokus)
      const warm = (e) => {
        const btn = e.target instanceof Element ? e.target.closest('[data-gcs-mini-add]') : null;
        if (!btn || (e.type === 'pointerover' && e.pointerType !== 'mouse')) return;
        this.productFor(btn).then((product) => product && recFlags(product));
      };
      el.addEventListener('pointerover', warm, { passive: true });
      el.addEventListener('touchstart', warm, { passive: true });
      el.addEventListener('focusin', warm);
      // Escape in einer offenen Größenwahl der Mini-Karte schließt nur die Auswahl, nicht den Drawer (Capture vor GcsDrawer)
      el.addEventListener(
        'keydown',
        (e) => {
          if (e.key !== 'Escape' || !(e.target instanceof Element) || !e.target.closest('.gcs-mini-card.is-picking')) return;
          e.preventDefault();
          e.stopPropagation();
          this.closePicker(true);
        },
        true
      );
      views.add(this);
    }

    q(selector) {
      return this.el.querySelector(selector);
    }

    visible() {
      return this.context === 'page' || (typeof this.el.isOpen === 'boolean' ? this.el.isOpen : true);
    }

    syncBusy() {
      const busy = state.busy > 0 || this.pending.size > 0;
      this.el.classList.toggle('is-busy', busy);
      const totals = this.q('[data-gcs-cart-totals]');
      if (totals) totals.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    render(cart, { force = false, added = [] } = {}) {
      const sig = signature(cart);
      const filled = cart.item_count > 0;
      this.el.querySelectorAll('[data-gcs-cart-filled]').forEach((n) => {
        n.hidden = !filled;
      });
      const empty = this.q('[data-gcs-cart-empty]');
      if (empty) empty.hidden = filled;
      this.el.querySelectorAll('[data-gcs-cart-packs]').forEach((n) => {
        n.textContent = packsLabel(cart.item_count);
      });

      if (force || sig !== this.sig) {
        const focus = this.captureFocus();
        const lines = this.q('[data-gcs-cart-lines]');
        const perProduct = productTotals(cart);
        if (lines) lines.innerHTML = cart.items.map((item, i) => renderLine(item, i + 1, this.context, perProduct)).join('');
        const totals = this.q('[data-gcs-cart-totals]');
        if (totals) totals.innerHTML = renderTotals(cart, this.taxesIncluded);
        const delivery = this.q('[data-gcs-cart-delivery]');
        if (delivery) delivery.innerHTML = renderDelivery(cart);
        const reward = this.q('[data-gcs-cart-reward]');
        if (reward) {
          const html = renderReward(cart, reward);
          const before = this.fillValue();
          reward.innerHTML = html;
          reward.hidden = !html;
          this.animateFill(before);
        }
        this.el.querySelectorAll('[data-gcs-cart-checkout-price]').forEach((n) => {
          n.textContent = money(cart.total_price);
        });
        this.applyPending();
        this.restoreFocus(focus);
        this.sig = sig;
        this.keepFocus();
      }

      if (added && added.length) {
        added.forEach((key) => {
          const line = this.lineByKey(key);
          if (line) {
            line.classList.remove('is-new');
            void line.offsetWidth; // Animation neu starten
            line.classList.add('is-new');
          }
        });
      }
      this.syncBusy();
      if (filled && (this.visible() || this.context === 'page')) this.renderRecs(cart);
    }

    /* Reward-Bar (Impeccable G7): Füllung per transform: scaleX(--gcs-fill) statt width. Nach dem Neu-Rendern startet
       die neue Leiste beim alten Stand und wächst im nächsten Frame auf den neuen (bei „Bewegung reduzieren“ sofort). */
    fillValue() {
      const fill = this.el.querySelector('.gcs-reward__fill');
      return fill ? fill.style.getPropertyValue('--gcs-fill') : '';
    }

    animateFill(before) {
      const fill = this.el.querySelector('.gcs-reward__fill');
      if (!fill || before === '') return;
      const target = fill.style.getPropertyValue('--gcs-fill');
      if (target === before) return;
      fill.style.setProperty('--gcs-fill', before);
      void fill.offsetWidth;
      requestAnimationFrame(() => fill.style.setProperty('--gcs-fill', target));
    }

    keepFocus() {
      // Wird ein fokussiertes Element ersetzt (Neu-Rendern, Größenwahl zu), bleibt der Fokus im Drawer.
      if (this.context !== 'drawer' || !this.el.isOpen) return;
      const active = document.activeElement;
      if (!active || active === document.body || !document.contains(active)) {
        const panel = this.el.querySelector('.gcs-drawer__panel');
        if (panel) panel.focus({ preventScroll: true });
      }
    }

    lineByKey(key) {
      return Array.from(this.el.querySelectorAll('[data-gcs-line]')).find((l) => l.getAttribute('data-key') === key) || null;
    }

    captureFocus() {
      const active = document.activeElement;
      if (!active || !this.el.contains(active)) return null;
      const line = active.closest('[data-gcs-line]');
      if (!line) return null;
      let selector = null;
      if (active.hasAttribute('data-gcs-qty')) selector = `[data-gcs-qty="${active.getAttribute('data-gcs-qty')}"]`;
      else if (active.hasAttribute('data-gcs-qty-input')) selector = '[data-gcs-qty-input]';
      else if (active.hasAttribute('data-gcs-remove')) selector = '[data-gcs-remove]';
      return { key: line.getAttribute('data-key'), index: Array.from(line.parentNode.children).indexOf(line), selector };
    }

    restoreFocus(info) {
      if (!info) return;
      const line = this.lineByKey(info.key);
      let target = line && info.selector ? line.querySelector(info.selector) : null;
      if (target && target.getAttribute('aria-disabled') === 'true') target = line.querySelector('[data-gcs-qty="1"]');
      if (!target) {
        const lines = this.el.querySelectorAll('[data-gcs-line]');
        const next = lines[Math.min(info.index, lines.length - 1)];
        target = next ? next.querySelector('[data-gcs-remove]') : this.el.querySelector('.gcs-drawer__panel') || this.el;
      }
      if (target && target.focus) target.focus({ preventScroll: true });
    }

    applyPending() {
      this.pending.forEach((qty, key) => {
        const line = this.lineByKey(key);
        if (!line) return;
        this.showQty(line, qty);
        line.classList.add('is-pending');
      });
    }

    showQty(line, qty) {
      const val = line.querySelector('[data-gcs-qty-val]');
      if (val) val.textContent = qty;
      const input = line.querySelector('[data-gcs-qty-input]');
      if (input && document.activeElement !== input) input.value = qty;
      const dec = line.querySelector('[data-gcs-qty="-1"]');
      if (dec) {
        if (qty > 1) dec.removeAttribute('aria-disabled');
        else dec.setAttribute('aria-disabled', 'true');
      }
    }

    step(line, delta) {
      const key = line.getAttribute('data-key');
      const base = this.pending.has(key) ? this.pending.get(key) : Number(line.getAttribute('data-qty'));
      const next = Math.max(1, base + delta);
      if (next === base) return;
      this.pending.set(key, next);
      this.showQty(line, next);
      line.classList.add('is-pending');
      this.syncBusy();
      clearTimeout(this.timers.get(key));
      this.timers.set(
        key,
        setTimeout(() => this.commit(key), 350)
      );
    }

    commit(key) {
      clearTimeout(this.timers.get(key));
      this.timers.delete(key);
      if (!this.pending.has(key)) return Promise.resolve();
      const qty = this.pending.get(key);
      const line = this.lineByKey(key);
      if (line && Number(line.getAttribute('data-qty')) === qty) {
        this.pending.delete(key);
        line.classList.remove('is-pending');
        this.syncBusy();
        return Promise.resolve();
      }
      return api
        .change(key, qty, { source: this.source })
        .catch((error) => this.showError(error.message))
        .finally(() => {
          if (this.pending.get(key) === qty) this.pending.delete(key);
          if (state.cart) this.render(state.cart, { force: true });
        });
    }

    flush() {
      return Promise.all(Array.from(this.pending.keys()).map((key) => this.commit(key))).then(() => chain);
    }

    remove(line) {
      if (!line) return;
      const key = line.getAttribute('data-key');
      clearTimeout(this.timers.get(key));
      this.timers.delete(key);
      this.pending.delete(key);
      line.classList.add('is-removing');
      api.change(key, 0, { source: this.source }).catch((error) => {
        line.classList.remove('is-removing');
        this.showError(error.message);
      });
    }

    showError(message) {
      const box = this.q('[data-gcs-cart-error]');
      if (!box || !this.visible()) {
        if (typeof GCS.toast === 'function') GCS.toast(message || DEFAULT_ERROR, { type: 'error' });
        return;
      }
      box.textContent = message || DEFAULT_ERROR;
      box.hidden = false;
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(() => {
        box.hidden = true;
      }, 6000);
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const qtyBtn = target.closest('[data-gcs-qty]');
      if (qtyBtn && this.el.contains(qtyBtn)) {
        event.preventDefault();
        if (qtyBtn.getAttribute('aria-disabled') === 'true') return;
        // A7: „+1 Pack“ der Warenkorb-Botschaft liegt außerhalb der Position und nennt sie per data-key
        const qtyLine = qtyBtn.closest('[data-gcs-line]') || this.lineByKey(qtyBtn.getAttribute('data-key'));
        if (qtyLine) this.step(qtyLine, Number(qtyBtn.getAttribute('data-gcs-qty')) || 0);
        return;
      }

      const removeBtn = target.closest('[data-gcs-remove]');
      if (removeBtn && this.el.contains(removeBtn)) {
        event.preventDefault();
        this.remove(removeBtn.closest('[data-gcs-line]'));
        return;
      }

      const recAdd = target.closest('[data-gcs-mini-add]');
      if (recAdd && this.el.contains(recAdd)) {
        event.preventDefault();
        const variantId = recAdd.getAttribute('data-variant-id');
        if (variantId) this.addRec(variantId, recAdd, recAdd.hasAttribute('data-variant-preorder'));
        else this.openPicker(recAdd);
        return;
      }

      const tile = target.closest('[data-gcs-rec-variant]');
      if (tile) {
        event.preventDefault();
        this.addRec(tile.getAttribute('data-gcs-rec-variant'), tile);
        return;
      }
    }

    onChange(event) {
      const input = event.target instanceof Element ? event.target.closest('[data-gcs-qty-input]') : null;
      if (!input) return;
      const line = input.closest('[data-gcs-line]');
      let qty = parseInt(input.value, 10);
      if (Number.isNaN(qty) || qty < 0) qty = 0;
      if (qty === 0) {
        this.remove(line);
        return;
      }
      const key = line.getAttribute('data-key');
      this.pending.set(key, qty);
      line.classList.add('is-pending');
      this.syncBusy();
      this.commit(key);
    }

    onSubmit(event) {
      const form = event.target;
      const submitter = event.submitter || null;
      const focusedInput = form.querySelector('[data-gcs-qty-input]:focus');
      const isCheckout = submitter ? submitter.name === 'checkout' : form.hasAttribute('data-gcs-checkout') || !focusedInput;
      if (!isCheckout) {
        // Enter im Mengenfeld: Feld übernehmen statt Seite neu laden
        event.preventDefault();
        if (focusedInput) focusedInput.blur();
        return;
      }
      if (this.pending.size || state.busy) {
        event.preventDefault();
        const button = submitter || form.querySelector('[name="checkout"]');
        if (button) button.setAttribute('aria-busy', 'true');
        this.flush().then(() => {
          window.location.href = `${root()}checkout`;
        });
      }
    }

    /* Empfehlungen */
    renderRecs(cart) {
      const box = this.q('[data-gcs-cart-recs]');
      if (!box || box.getAttribute('data-enabled') === 'false') return;
      const token = signature(cart);
      this.recToken = token;
      recommendationsFor(cart)
        .then((products) => {
          if (this.recToken !== token) return;
          const rail = box.querySelector('[data-gcs-recs-list]');
          if (!products.length || !rail) {
            box.hidden = true;
            return;
          }
          const ids = products.map((p) => p.id).join(',');
          if (ids !== this.recIds) {
            this.recIds = ids;
            this.recProducts = new Map(products.map((p) => [String(p.id), p]));
            // Cross-Sell als Mini-Karten (Runde D) in einer wischbaren Reihe, Plus mit Größenwahl in der Karte
            rail.innerHTML = products.map((p) => renderMiniCard(p, { add: 'inline', tag: 'li' })).join('');
            rail.scrollLeft = 0;
            this.closePicker(false);
            this.keepFocus();
          }
          box.hidden = false;
        })
        .catch(() => {
          box.hidden = true;
        });
    }

    recProduct(el) {
      const holder = el && el.closest('[data-product-id]');
      return (holder && this.recProducts.get(holder.getAttribute('data-product-id'))) || null;
    }

    /* Produkt-JSON zur Karte: aus den Empfehlungen oder (serverseitig gerenderte Mini-Karte) /products/<handle>.js */
    productFor(el) {
      const known = this.recProduct(el);
      if (known) return Promise.resolve(known);
      const holder = el && el.closest('[data-product-id]');
      const handle = holder && holder.getAttribute('data-product-handle');
      if (!handle) return Promise.resolve(null);
      if (!productCache.has(handle)) {
        productCache.set(
          handle,
          window
            .fetch(`${root()}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
            .then((p) => {
              if (!p) productCache.delete(handle);
              return p;
            })
        );
      }
      return productCache.get(handle).then((p) => {
        if (p) this.recProducts.set(String(p.id), p);
        return p;
      });
    }

    /* Größenwahl in der Mini-Karte ([data-gcs-mini-picker]) */
    pickerFor(button) {
      const card = button.closest('.gcs-mini-card');
      return (card && card.querySelector('[data-gcs-mini-picker]')) || null;
    }

    /* „Vorbestellung“ an Größen wie im Schnellkauf: nur, wenn das Produkt auch Ware auf Lager hat */
    markPicker(product) {
      recFlags(product).then((flags) => {
        const picker = this.el.querySelector(`[data-picker-product="${product.id}"]:not([hidden])`);
        if (!flags || !picker) return;
        if (!Array.from(flags.values()).some((v) => v.available && !v.preorder)) return;
        picker.querySelectorAll('[data-gcs-rec-variant]').forEach((tile) => {
          const v = flags.get(tile.getAttribute('data-gcs-rec-variant'));
          if (!v || !v.preorder || tile.disabled || tile.querySelector('.gcs-picker__sub')) return;
          tile.insertAdjacentHTML('beforeend', '<span class="gcs-picker__sub">Vor&shy;bestellung</span>');
        });
      });
    }

    async openPicker(button) {
      const picker = this.pickerFor(button);
      if (!picker) return;
      if (button.getAttribute('aria-expanded') === 'true') {
        this.closePicker(true);
        return;
      }
      const product = await this.productFor(button);
      if (!product || !document.contains(button)) return;
      const variants = product.variants || [];
      if (variants.length > 8) {
        window.location.href = product.url || `${root()}products/${product.handle}`;
        return;
      }
      this.closePicker(false);
      const title = cleanTitle(product.title);
      const onlySize = (product.options || []).length <= 1;
      const groupLabel = `${onlySize ? 'Größe' : 'Variante'} für ${esc(title)}`;
      const tiles = `<div class="gcs-picker__tiles" role="group" aria-label="${groupLabel}">${variants
        .map(
          (v) =>
            `<button type="button" class="gcs-picker__tile" data-gcs-rec-variant="${v.id}"${v.available ? '' : ' disabled'}>${esc(variantLabel(v))}${
              v.available ? '' : '<span class="gcs-picker__sub">ausverkauft</span>'
            }</button>`
        )
        .join('')}</div>`;
      const card = picker.closest('.gcs-mini-card');
      picker.innerHTML = `<p class="gcs-mini-card__picker-label" aria-hidden="true">${onlySize ? 'Größe wählen' : 'Variante wählen'}</p>${tiles}`;
      picker.hidden = false;
      picker.setAttribute('data-picker-product', String(product.id));
      picker.id = picker.id || `GcsPicker-${this.context}-${product.id}`;
      if (card) card.classList.add('is-picking');
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-controls', picker.id);
      button.id = button.id || `GcsRecAdd-${this.context}-${product.id}`;
      this.markPicker(product);
      const first = picker.querySelector('[data-gcs-rec-variant]:not([disabled])');
      if (first) first.focus({ preventScroll: true });
      if (picker.scrollIntoView) picker.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    closePicker(restoreFocus) {
      let focused = false;
      this.el.querySelectorAll('[data-gcs-mini-picker]:not([hidden])').forEach((picker) => {
        picker.hidden = true;
        picker.innerHTML = '';
        picker.removeAttribute('data-picker-product');
        const card = picker.closest('.gcs-mini-card');
        if (card) card.classList.remove('is-picking');
        const button = card && card.querySelector('[data-gcs-mini-add]');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
          if (restoreFocus && !focused) {
            button.focus({ preventScroll: true });
            focused = true;
          }
        }
      });
    }

    addRec(variantId, button, preorderKnown = false) {
      if (!variantId || button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      // Flags meist schon vorgeladen; höchstens 6 s warten, dann Produkt-Regel
      this.productFor(button)
        .then((product) => {
          if (preorderKnown || !product) return { product, map: null };
          return Promise.race([recFlags(product), new Promise((resolve) => setTimeout(() => resolve(null), 6000))]).then((map) => ({ product, map }));
        })
        .then(({ product, map }) => {
          const item = { id: Number(variantId), quantity: 1 };
          if (preorderKnown || (product && recPreorder(map, product, variantId))) item.properties = Object.assign({}, PREORDER_PROPERTIES);
          return api.add([item], { source: this.context === 'page' ? 'cart-page' : 'drawer', open: this.context !== 'page' });
        })
        .then(() => this.closePicker(false))
        .catch((error) => this.showError(error.message))
        .finally(() => {
          button.removeAttribute('aria-busy');
          this.keepFocus();
        });
    }
  }

  /* 10 Custom Elements ---------------------------------------------------------------------------- */
  const BaseDrawer = GCS.DrawerElement || HTMLElement;

  class GcsCartDrawer extends BaseDrawer {
    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();
      if (GCS.drawers && GCS.drawers.add) GCS.drawers.add(this);
      if (!this._gcsEsc) {
        // Escape auch dann, wenn der Fokus (z. B. nach dem Neu-Rendern) nicht mehr im Drawer liegt
        this._gcsEsc = (event) => {
          if (event.key === 'Escape' && this.isOpen && !this.contains(event.target)) this.close();
        };
        document.addEventListener('keydown', this._gcsEsc);
      }
      if (!this.view) {
        readMeta(this);
        if (state.sig == null) state.sig = this.getAttribute('data-gcs-sig');
        this.view = new CartView(this, 'drawer');
      }
    }

    disconnectedCallback() {
      if (super.disconnectedCallback) super.disconnectedCallback();
      if (GCS.drawers && GCS.drawers.delete) GCS.drawers.delete(this);
    }

    show({ refresh = true, opener } = {}) {
      if (!this.isOpen && typeof this.open === 'function') this.open(opener || document.activeElement);
      if (refresh) api.refresh().catch(() => {});
      else if (state.cart) this.view.renderRecs(state.cart);
    }

    close(options) {
      if (this.view) this.view.closePicker(false);
      if (super.close) super.close(options);
    }
  }
  if (!customElements.get('gcs-cart-drawer')) customElements.define('gcs-cart-drawer', GcsCartDrawer);

  class GcsCartPage extends HTMLElement {
    connectedCallback() {
      if (this.view) return;
      readMeta(document);
      this.view = new CartView(this, 'page');
      api.refresh().catch(() => {});
    }
  }
  if (!customElements.get('gcs-cart-page')) customElements.define('gcs-cart-page', GcsCartPage);

  /* 11 Klick auf den Header-Warenkorb: eigener Drawer statt /cart oder EGO ---------------------------- */
  const isCartTemplate = () => {
    const main = document.querySelector('main[data-template]');
    if (main) return main.getAttribute('data-template') === 'cart';
    return /\/cart\/?$/.test(window.location.pathname);
  };
  const isCartLink = (link) => {
    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === routes().cart.replace(/\/$/, '');
    } catch (e) {
      return false;
    }
  };
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const toggle = target.closest('[data-gcs-cart-toggle]');
      if (toggle) {
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          toggle.classList.add('opusNoClick'); // neuer Tab: normal zu /cart, EGO bleibt draußen
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (isCartTemplate()) {
          const page = document.querySelector('gcs-cart-page');
          if (page) page.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        api.open({ refresh: true, opener: toggle });
        return;
      }
      // Andere Links auf /cart: normal navigieren lassen, EGO/Opus soll sie nicht abfangen
      const link = target.closest('a[href]');
      if (link && isCartLink(link)) link.classList.add('opusNoClick');
    },
    true
  );

  /* 12 Nebenwirkungen von EGO/Opus neutralisieren (Body-Scroll-Lock) --------------------------------- */
  const guardBody = () => {
    const body = document.body;
    if (!body || !body.classList.contains('opus-modal-open')) return;
    body.classList.remove('opus-modal-open');
    if (body.style.overflowY === 'hidden') body.style.overflowY = '';
  };
  const watchBody = () => {
    if (!document.body) return;
    guardBody();
    new MutationObserver(guardBody).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  };

  /* 13 Fremde Warenkorb-Änderungen erkennen ---------------------------------------------------------- */
  const MUTATION_PATH = /\/cart\/(add|change|update|clear)(\.js|\.json)?$/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') return;
          let url;
          try {
            url = new URL(entry.name, window.location.href);
          } catch (e) {
            return;
          }
          if (url.origin !== window.location.origin || !MUTATION_PATH.test(url.pathname)) return;
          const own = !/opus/i.test(url.search) && ownWindows.some((w) => entry.startTime >= w.start - 20 && entry.startTime <= w.end);
          if (!own) syncExternal();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {
      /* ältere Browser: Sync über pub/sub, Sichtbarkeit und Öffnen */
    }
  }
  window.addEventListener('OpusCartChange', (event) => {
    const cart = event && event.detail;
    if (cart && Array.isArray(cart.items) && signature(cart) !== state.sig) syncExternal();
  });

  const listenPubSub = () => {
    const events = pubEvents();
    if (typeof window.subscribe !== 'function' || !events.cartUpdate) return;
    window.subscribe(events.cartUpdate, (event) => {
      if (!event || event.gcs) return;
      if (event.cartData && Array.isArray(event.cartData.items)) {
        if (signature(event.cartData) !== state.sig) setCart(event.cartData);
      } else {
        syncExternal();
      }
    });
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncExternal();
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) syncExternal();
  });

  const init = () => {
    listenPubSub();
    watchBody();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
